import React, { useState, useEffect } from 'react';

const InfoProveedorEvaluacion = ({ proveedorId, fechaEvaluacion }) => {
  const [datosProveedor, setDatosProveedor] = useState({
    razon_social: '',
    representante: '',
    servicios_prestados: '',
    fecha: fechaEvaluacion
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const formatFechaEcuador = (value) => {
    const date = value ? new Date(value) : new Date();
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleString('es-EC', {
      timeZone: 'America/Guayaquil',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(',', '');
  };

  useEffect(() => {
    const cargarDatosProveedor = async () => {
      if (!proveedorId) return;

      try {
        setLoading(true);

        const res = await fetch(`https://apiprov.conduto.com.ec/api/providers/ultimo-formulario/${proveedorId}`, {
          credentials: 'include'
        });

        if (res.ok) {
          const data = await res.json();

          if (data && data.proveedor_datos) {
            const tipoPersona = data.formulario?.tipo_persona;

            let representante = '';
            if (tipoPersona === 'juridica') {
              representante = data.proveedor_datos.representante_legal || '';
            } else {
              representante = data.proveedor_datos.razon_social || '';
            }

            setDatosProveedor({
              razon_social: data.proveedor_datos.razon_social || '',
              representante: representante,
              servicios_prestados: data.proveedor_datos.servicios_prestados || '',
              fecha: fechaEvaluacion
            });
          }
        } else {
          setError('No se encontraron datos del proveedor');
        }
      } catch (err) {
        console.error('Error cargando datos del proveedor:', err);
        setError('Error al cargar datos del proveedor');
      } finally {
        setLoading(false);
      }
    };

    cargarDatosProveedor();
  }, [proveedorId, fechaEvaluacion]);

  if (loading) {
    return (
      <div className="row mb-3">
        <div className="col-12">
          <div className="text-center py-3">
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <small className="ms-2">Cargando información del proveedor...</small>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="row mb-3">
        <div className="col-12">
          <div className="alert alert-warning py-2" role="alert">
            <small><i className="bi bi-exclamation-triangle me-1"></i> {error}</small>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row mb-3">
      <div className="col-md-6">
        <label className="fw-bold small">Razón Social:</label>
        <input
          className="form-control form-control-sm"
          value={datosProveedor.razon_social}
          disabled
        />
      </div>
      <div className="col-md-6">
        <label className="fw-bold small">Representante:</label>
        <input
          className="form-control form-control-sm"
          value={datosProveedor.representante}
          disabled
        />
      </div>
      <div className="col-md-6">
        <label className="fw-bold small">Materiales/Servicio:</label>
        <input
          className="form-control form-control-sm"
          value={datosProveedor.servicios_prestados}
          disabled
        />
      </div>
      {console.log('Fecha de Evaluación en InfoProveedorEvaluacion:', fechaEvaluacion)}
      <div className="col-md-6">
        <label className="fw-bold small">Fecha de Evaluación:</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formatFechaEcuador(fechaEvaluacion)}
          disabled
        />
      </div>
    </div>
  );
};

export default InfoProveedorEvaluacion;